import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BookOpen } from 'lucide-react';
import { Filigree, StarDivider } from '../Ornaments';
import { Reveal } from '../Reveal';

const ArtifactCard = ({ artifact, realmName, delay = 0 }) => (
  <Reveal delay={delay}>
    <article className="vitrine" data-testid={`artifact-card-${artifact.slug}`}>
      <Filigree className="!inset-1.5 text-[#C8A45D]/70" />
      <Link to={`/product/${artifact.slug}`} className="vitrine-image" aria-label={`View ${artifact.name}`}>
        <img src={artifact.image} alt={`${artifact.name} — ${realmName}`} loading="lazy" draggable="false" />
      </Link>
      <div className="vitrine-body">
        <h3 className="vitrine-name">{artifact.name}</h3>
        <p className="vitrine-type">{artifact.type}</p>
        <p className="vitrine-caption">{artifact.caption[0]}<br />{artifact.caption[1]}</p>
        <Link to={`/product/${artifact.slug}`} className="vitrine-view" data-testid={`artifact-view-${artifact.slug}`}>
          View
          <span className="vitrine-view-rule" aria-hidden><i /><b>✦</b><i /></span>
        </Link>
      </div>
    </article>
  </Reveal>
);

export const ArtifactsSection = ({ realm, featured, more }) => {
  const [expanded, setExpanded] = useState(false);
  const list = expanded ? [...featured, ...more] : featured;

  return (
    <section id="artifacts" className="artifacts" data-testid="artifacts-section">
      <div className="artifacts-inner">
        <Reveal className="artifacts-intro">
          <h2 className="artifacts-title" data-testid="artifacts-title">Artifacts of {realm.name}</h2>
          <StarDivider className="artifacts-rule mt-3" />
          <p className="artifacts-desc">
            {realm.artifactsIntro.split('\n').map((line, i) => (
              <React.Fragment key={line}>{i > 0 && <br />}{line}</React.Fragment>
            ))}
          </p>
          <img src={realm.lineArt} alt="" className="artifacts-art" draggable="false" aria-hidden />
          <div className="lookbook" data-testid="lookbook-btn">
            <span className="lookbook-btn" aria-disabled="true">
              <BookOpen className="w-4 h-4" strokeWidth={1.25} />
              View {realm.name} Lookbook
            </span>
            <span className="lookbook-soon">Coming soon</span>
          </div>
        </Reveal>

        <div className="artifacts-grid-wrap">
          <div className="artifacts-grid" data-testid="artifacts-grid">
            {list.map((a, i) => <ArtifactCard key={a.slug} artifact={a} realmName={realm.name} delay={(i % 4) * 90} />)}
          </div>
          <div className="artifacts-more">
            {expanded ? (
              <p className="artifacts-all" data-testid="artifacts-all-shown">All artifacts shown.</p>
            ) : (
              <button type="button" className="artifacts-viewall" onClick={() => setExpanded(true)} data-testid="view-all-artifacts-btn">
                View All Artifacts
                <span className="vitrine-view-rule" aria-hidden><i /><b>✦</b><i /></span>
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
